import * as Types from '../../../../@types/graphql-types';

import { TitleOfferFragment } from '../fragments/Offer.fragment';
import gql from 'graphql-tag';
import { TitleOfferFragmentDoc } from '../fragments/Offer.fragment';
export type GetTitleOffersPromotedQueryVariables = Types.Exact<{
	nodeId: Types.Scalars['ID'];
	country: Types.Scalars['Country'];
	language: Types.Scalars['Language'];
}>;

export type GetTitleOffersPromotedQuery = { __typename?: 'Query' } & {
	node?: Types.Maybe<
		| ({ __typename?: 'Article' } & Pick<Types.Article, 'id'>)
		| ({ __typename?: 'Author' } & Pick<Types.Author, 'id'>)
		| ({ __typename?: 'Bundle' } & Pick<Types.Bundle, 'id'>)
		| ({ __typename?: 'Device' } & Pick<Types.Device, 'id'>)
		| ({ __typename?: 'Episode' } & Pick<Types.Episode, 'id'>)
		| ({ __typename?: 'GenericTitleList' } & Pick<Types.GenericTitleList, 'id'>)
		| ({ __typename?: 'Genre' } & Pick<Types.Genre, 'id'>)
		| ({ __typename?: 'Movie' } & Pick<Types.Movie, 'id'> & {
					promotedBundles: Array<
						{ __typename?: 'PromotedBundleEdge' } & Pick<Types.PromotedBundleEdge, 'promotionUrl'> & {
								node: { __typename?: 'Bundle' } & Pick<
									Types.Bundle,
									'id' | 'clearName' | 'icon' | 'technicalName' | 'bundleId'
								>;
								offer: { __typename?: 'Offer' } & {
									package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'technicalName'>;
								} & TitleOfferFragment;
							}
					>;
					promotedOffers: Array<{ __typename?: 'Offer' } & TitleOfferFragment>;
				})
		| ({ __typename?: 'MultiStepSportEvent' } & Pick<Types.MultiStepSportEvent, 'id'>)
		| ({ __typename?: 'Offer' } & Pick<Types.Offer, 'id'>)
		| ({ __typename?: 'Package' } & Pick<Types.Package, 'id'>)
		| ({ __typename?: 'Page' } & Pick<Types.Page, 'id'>)
		| ({ __typename?: 'Person' } & Pick<Types.Person, 'id'>)
		| ({ __typename?: 'Season' } & Pick<Types.Season, 'id'> & {
					promotedBundles: Array<
						{ __typename?: 'PromotedBundleEdge' } & Pick<Types.PromotedBundleEdge, 'promotionUrl'> & {
								node: { __typename?: 'Bundle' } & Pick<
									Types.Bundle,
									'id' | 'clearName' | 'icon' | 'technicalName' | 'bundleId'
								>;
								offer: { __typename?: 'Offer' } & {
									package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'technicalName'>;
								} & TitleOfferFragment;
							}
					>;
					promotedOffers: Array<{ __typename?: 'Offer' } & TitleOfferFragment>;
				})
		| ({ __typename?: 'Show' } & Pick<Types.Show, 'id'> & {
					promotedBundles: Array<
						{ __typename?: 'PromotedBundleEdge' } & Pick<Types.PromotedBundleEdge, 'promotionUrl'> & {
								node: { __typename?: 'Bundle' } & Pick<
									Types.Bundle,
									'id' | 'clearName' | 'icon' | 'technicalName' | 'bundleId'
								>;
								offer: { __typename?: 'Offer' } & {
									package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'technicalName'>;
								} & TitleOfferFragment;
							}
					>;
					promotedOffers: Array<{ __typename?: 'Offer' } & TitleOfferFragment>;
				})
		| ({ __typename?: 'SingleStepSportEvent' } & Pick<Types.SingleStepSportEvent, 'id'>)
		| ({ __typename?: 'SportCompetitionV2' } & Pick<Types.SportCompetitionV2, 'id'>)
		| ({ __typename?: 'SportCompetitorV2' } & Pick<Types.SportCompetitorV2, 'id'>)
		| ({ __typename?: 'Url' } & Pick<Types.Url, 'id'>)
	>;
};

export const GetTitleOffersPromotedDocument = gql`
	query GetTitleOffersPromoted($nodeId: ID!, $country: Country!, $language: Language!) {
		node(id: $nodeId) {
			id
			... on MovieOrShowOrSeason {
				promotedBundles(country: $country, platform: WEB) {
					node {
						id
						clearName
						icon(profile: S100)
						technicalName
						bundleId
					}
					promotionUrl
					offer {
						...TitleOffer
						package {
							id
							technicalName
						}
					}
				}
				promotedOffers(country: $country, platform: WEB, filter: { bestOnly: true }) {
					...TitleOffer
				}
			}
		}
	}
	${TitleOfferFragmentDoc}
`;
